export const CELL_TARGET_UNIVERSE_OPTIONS = [
    {label: "NATURAL ENHANCED", value: "natural enhanced"},
    {label: "REGIONAL GROCERY", value: "regional grocery"},
    {label: "SPINS PET", value: "spins pet"},
    {label: "CIRCANA PET", value: "circana pet"},
    {label: "INFRA", value: "infra"},
    {label: "C AND S", value: "c and s"}
];

export const cellTargetUniverseParam = (universe) => universe.replaceAll(' ', '_');
